module.exports = __webpack_public_path__ + "media/club_product_v2/stats_center-3c774068.webp";